export function insertIf<T>(condition: boolean, elements: T[]) {
  return condition ? elements : []
}

export function renderArrayLabel(
  data: string | number | string[],
  inline: boolean = true,
  lastSeparator: string = 'and'
) {
  if (Array.isArray(data)) {
    if (data.length <= 1) {
      const onlyElement = data[0]
      return onlyElement
    } else if (inline && lastSeparator) {
      const allButLast = data.slice(0, -1)
      const last = data.slice(-1)
      return `${allButLast.join(', ')} ${lastSeparator} ${last}`
    } else {
      return data.join('\n')
    }
  } else {
    return data.toString()
  }
}

export * from './immutableArray.helpers'
